var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.areThereAnyTests
    ? _c(
        "div",
        { staticClass: "assigned-tests" },
        [
          _c("h3", { staticClass: "section-title" }, [
            _vm._v(
              "\n    " + _vm._s(_vm.$t("KNOWLEDGE_TEST_FOCUS_TITLE")) + "\n  "
            ),
          ]),
          _vm._v(" "),
          _vm._l(_vm.knowledgeTestsArray, function (test) {
            return _c(
              "div",
              {
                key: test.id,
                staticClass: "card knowledge-test-card",
                class: {
                  "knowledge-test-warning":
                    !_vm.didUserPassTest(test.id) &&
                    _vm.isTestClosingSoon(test.id),
                },
              },
              [
                _c("div", { staticClass: "test-specific-part" }, [
                  _c("div", { staticClass: "test-name-row" }, [
                    _c("h2", [
                      _vm._v(
                        _vm._s(
                          test.title || _vm.$t("KNOWLEDGE_TEST_FOCUS_TITLE")
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass:
                          "label label-important test-deadline-label",
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("translate")("KNOWLEDGE_TEST_DEADLINE")
                            ) +
                            " " +
                            _vm._s(test.open_to_formatted) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "test-status-row" },
                    [
                      _vm.isAttemptForTestActive(test.id)
                        ? _c(
                            "p",
                            { staticClass: "previous-attempt attempt-running" },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm._f("translate")(
                                      "KNOWLEDGE_TEST_UNFINISHED_ATTEMPT"
                                    )
                                  ) +
                                  "\n        "
                              ),
                            ]
                          )
                        : !_vm.isEmpty(_vm.bestTestAttempt(test.id))
                        ? [
                            _vm.bestTestAttempt(test.id).result === null
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "previous-attempt attempt-manual",
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "label label-default" },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm._f("translate")(
                                                "KNOWLEDGE_TEST_PREVIOUS_MANUAL"
                                              )
                                            ) +
                                            "\n            "
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _c(
                                  "p",
                                  {
                                    staticClass: "previous-attempt",
                                    class:
                                      _vm.bestTestAttempt(test.id).result ===
                                      true
                                        ? "attempt-success"
                                        : "attempt-fail",
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm._f("translate")(
                                            "KNOWLEDGE_TEST_YOUR_RESULT"
                                          )
                                        ) +
                                        "\n            " +
                                        _vm._s(
                                          _vm.bestTestAttempt(test.id)
                                            .percentage
                                        ) +
                                        "%\n            "
                                    ),
                                    _vm.bestTestAttempt(test.id).result === true
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "label label-success",
                                          },
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(
                                                  _vm._f("translate")(
                                                    "KNOWLEDGE_TEST_PREVIOUS_SUCCESS"
                                                  )
                                                ) +
                                                "\n            "
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "span",
                                          { staticClass: "label label-danger" },
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(
                                                  _vm._f("translate")(
                                                    "KNOWLEDGE_TEST_PREVIOUS_FAIL"
                                                  )
                                                ) +
                                                "\n            "
                                            ),
                                          ]
                                        ),
                                  ]
                                ),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isAttemptForTestActive(test.id)
                        ? _c(
                            "p",
                            { staticClass: "test-attempts-count" },
                            [
                              _vm.remainingTestAttempts(test.id) === 0
                                ? [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm._f("translate")(
                                            "KNOWLEDGE_TEST_ATTEMPTS_0"
                                          )
                                        ) +
                                        "\n          "
                                    ),
                                  ]
                                : _vm.remainingTestAttempts(test.id) === 1
                                ? [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm._f("translate")(
                                            "KNOWLEDGE_TEST_ATTEMPTS_1"
                                          )
                                        ) +
                                        "\n          "
                                    ),
                                  ]
                                : _vm.remainingTestAttempts(test.id) <= 4
                                ? [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.$t(
                                            "KNOWLEDGE_TEST_ATTEMPTS_2_4",
                                            {
                                              count: _vm.remainingTestAttempts(
                                                test.id
                                              ),
                                            }
                                          )
                                        ) +
                                        "\n          "
                                    ),
                                  ]
                                : [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.$t(
                                            "KNOWLEDGE_TEST_ATTEMPTS_5_MORE",
                                            {
                                              count: _vm.remainingTestAttempts(
                                                test.id
                                              ),
                                            }
                                          )
                                        ) +
                                        "\n          "
                                    ),
                                  ],
                            ],
                            2
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "test-button-row" }, [
                    _vm.isAttemptForTestActive(test.id)
                      ? _c(
                          "button",
                          {
                            staticClass: "btn primary-btn",
                            on: {
                              click: function ($event) {
                                return _vm.continueAttempt()
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm._f("translate")(
                                    "KNOWLEDGE_TEST_CONTINUE_ATTEMPT"
                                  )
                                ) +
                                "\n        "
                            ),
                          ]
                        )
                      : _c(
                          "button",
                          {
                            staticClass: "btn primary-btn",
                            attrs: {
                              disabled:
                                _vm.remainingTestAttempts(test.id) === 0 ||
                                _vm.isAnyAttemptActive,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.showStartModal(test.id)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm._f("translate")(
                                    "KNOWLEDGE_TEST_START_ATTEMPT"
                                  )
                                ) +
                                "\n        "
                            ),
                          ]
                        ),
                  ]),
                ]),
              ]
            )
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }